<div mat-dialog-title class="markdown-title"><h4><strong>{{alert?.title}}</strong></h4></div>
<mat-dialog-content aria-label="Dialog Content">
  <div>
    <div class="modal-body">
      <div>
        <span class="fs-17 mb-2">{{ alert?.message }}</span>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" aria-label="Dialog Actions" class="d-flex flex-column flex-sm-row align-items-stretch gap-2">
  <button [id]="ids" class='btn btn-primary order-2 order-md-1'
    (click)="target()">{{alert?.buttonText }}</button>
</mat-dialog-actions>